interface MDFileIconProps {
    size?: number
    className?: string
}

export function MDFileIcon({ size = 16, className = '' }: MDFileIconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            {/* File background with folded corner */}
            <path
                d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z"
                fill="#4A90E2"
            />
            <path
                d="M14 2V8H20"
                fill="#357ABD"
            />

            {/* MD text */}
            <text
                x="12"
                y="11"
                fontSize="6"
                fontWeight="bold"
                fill="white"
                textAnchor="middle"
                fontFamily="Arial, sans-serif"
            >
                MD
            </text>

            {/* Database icon */}
            <g transform="translate(7, 13)">
                {/* Top ellipse */}
                <ellipse
                    cx="5"
                    cy="1.5"
                    rx="4"
                    ry="1.2"
                    fill="white"
                    stroke="white"
                    strokeWidth="0.3"
                />
                {/* Middle section */}
                <path
                    d="M1 1.5 V 4 C1 4.7 2.8 5.2 5 5.2 C7.2 5.2 9 4.7 9 4 V 1.5"
                    fill="white"
                    stroke="white"
                    strokeWidth="0.3"
                />
                {/* Bottom ellipse */}
                <ellipse
                    cx="5"
                    cy="4"
                    rx="4"
                    ry="1.2"
                    fill="none"
                    stroke="white"
                    strokeWidth="0.3"
                />
                {/* Database lines */}
                <line x1="1.5" y1="2" x2="1.5" y2="3.5" stroke="white" strokeWidth="0.3" />
                <line x1="8.5" y1="2" x2="8.5" y2="3.5" stroke="white" strokeWidth="0.3" />
            </g>
        </svg>
    )
}
